import cx from 'classnames';

import type { BlockViewProps } from '@plone/types';

import type { ProductsSliderData } from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/schema';
import Slider from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/Slider/Slider';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/ProductsSlider/styles.module.css';

type ProductsSliderViewProps = Omit<BlockViewProps, 'data'> & {
  data: ProductsSliderData;
};

const View = (props: ProductsSliderViewProps) => {
  const { className, data } = props;

  return (
    <section
      className={cx('block-products-slider', styles.block, className, {
        'mobile-fullwidth-fix': data.styles.fullwidth,
      })}
    >
      <div className={`volto-carousel-template-wrapper`}>
        {data.title && (
          <div className={styles.blockTitle}>
            <h2>{data.title}</h2>
          </div>
        )}
        {data.description && (
          <div className={styles.blockDescription}>
            <p>{data.description}</p>
          </div>
        )}
        <Slider slides={data.slides} />
      </div>
    </section>
  );
};

export default View;
